export default "__VITE_ASSET__5L6TRFE6__"